import { FC } from "react";
import { PatientInformationProps } from "../showPatientInformation/types";



const ShowPatientTreatment: FC<PatientInformationProps> = ({ getValues }): JSX.Element => {
  const { prescription_attributes } = getValues();

  return (
     <div className="card my-3">
          <div className="card-header">
            <h1 className="m-0">Provide Patient Training</h1>
          </div>
          <div className="card-body">
            <div className="row p-2">
              
              <div className="col-lg-6 col-md-6 col-12">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label my-3 my-lg-3">Provide Patient Training:</label>
                  </div>
                  <div className="col-6">
                    <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.Patient_training_required ? 'Yes' : 'No'}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label my-3 my-lg-3">Target After Meal Blood Glucose Min:</label>
                  </div>
                  <div className="col-6">
                    <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.targetAfterMealBloodGlucoseMin ? prescription_attributes.targetAfterMealBloodGlucoseMin : 'N/A'}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label my-3 my-lg-3">Target After Meal Blood Glucose Max:</label>
                  </div>
                  <div className="col-6">
                    <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.targetAfterMealBloodGlucoseMax ? prescription_attributes.targetAfterMealBloodGlucoseMax : 'N/A'}</p>
                  </div>
                </div>
              </div>

     {/* <p className="mb-2">
        <sup className="fs-5 top-0">*</sup>The American Diabetes Association suggests assessing
        post-meal blood glucose 1–2 hours after the start of a meal.
      </p>

      <p className="mb-2">
        Continue adjusting dose every <strong>3–4 days</strong>, or{" "}
        <strong>twice weekly</strong>, if blood glucose is below or above
        target, until after-meal blood glucose is consistently within your
        target range up to the maximum daily dose.<sup className="fs-5 top-0">*</sup>
      </p>

      <p className="mb-2">
        <sup className="fs-5 top-0">*</sup>The American Diabetes Association suggests insulin
        regimens be adjusted every 3–4 days until self-monitored blood glucose
        targets are reached.
      </p>

      <p className="mb-2">
        <sup className="fs-5 top-0">**</sup>To opt out of Patient Training, please contact{" "}
        <strong>MannKind Cares at 1-844-323-7399</strong>.
      </p> */}
      <ul>
                <li>
                    The American Diabetes Association suggests assessing post-meal blood glucose 1–2 hours after the start of a meal.
                </li>
                <li>
                    Continue adjusting dose every <strong>3–4 days</strong>, or{" "}
                    <strong>twice weekly</strong>, if blood glucose is below or above
                    target, until after-meal blood glucose is consistently within your
                    target range up to the maximum daily dose.
                </li>
                <li>
                    The American Diabetes Association suggests insulin
                    regimens be adjusted every 3–4 days until self-monitored blood glucose
                    targets are reached.
                </li>
                <li>
                    To opt out of Patient Training, please contact{" "}
                    <strong>MannKind Cares at 1-844-323-7399</strong>.
                </li>
            </ul>
             
              
            </div>
          </div>
        </div>
  );
    
};

export default ShowPatientTreatment;
